<div class="onboarding-tips__overlay onboarding-tips--visible">
  <div class="onboarding-tips onboarding-tips--welcome-modal">
    <div class="onboarding-tips__image onboarding-tips__image--welcome"></div>
    <div class="onboarding-tips__content">
      <h2 class="onboarding-tips__title"><ng-container i18n="@@common.welcome">Welcome</ng-container>, {{ data.name }}</h2>
      <div class="onboarding-tips__desc" i18n="@@common.aff_area_welcome_hint">
        Affiliate Area is represented as a part of our <b>Partner Platform</b> product specially developed for affiliates like you. We'd
        love to show you around! It should only take a minute or two
      </div>
      <div class="onboarding-tips__buttons">
        <button
          type="button"
          p500-ui-button
          class="--protection__button onboarding-tips__button onboarding-tips__button--cancel"
          (click)="disablesTips()"
        >
          <span i18n="@@common.no_thanks">No thanks</span>
        </button>
        <button
          type="button"
          p500-ui-button
          class="--protection__button onboarding-tips__button"
          [routerLink]="['/app/account-protection/']"
          (click)="hideModal()"
        >
          <span i18n="@@common.lets_go">Let’s Go</span>
        </button>
      </div>
    </div>
  </div>
</div>
